var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.355,
    height: 53.301,
    viewBox: "0 0 49.355 53.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_938",
    "data-name": "Rectangle 938",
    width: 49.355,
    height: 53.301,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6027",
    "data-name": "Groupe 6027",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6026",
    "data-name": "Groupe 6026",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26747",
    "data-name": "Trac\\xE9 26747",
    d: "M51.032,15.109l0,0-1.608-1.317-.641.4L20.389,3.17a1.62,1.62,0,0,0-2.087.975L6.065,40.75l-1.777,1.1A20.815,20.815,0,0,0,6.561,43.6L40.475,54.827a1.617,1.617,0,0,0,2.051-1.117l9.034-37.189a1.328,1.328,0,0,0-.527-1.412",
    transform: "translate(-2.244 -1.605)",
    fill: "#59443a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26748",
    "data-name": "Trac\\xE9 26748",
    d: "M38.2,51.76,4.29,40.532a1.344,1.344,0,0,1-.872-1.725L16.031,1.078A1.62,1.62,0,0,1,18.118.1L48.453,11.871a1.34,1.34,0,0,1,.836,1.583L40.254,50.643A1.616,1.616,0,0,1,38.2,51.76",
    transform: "translate(-1.75 0)",
    fill: "#ad8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26749",
    "data-name": "Trac\\xE9 26749",
    d: "M15.309,6.688,46.977,18.462S38.31,43.479,36.73,44.151L6.146,33.883s2.129-3.083,9.163-27.2",
    transform: "translate(-3.216 -3.499)",
    fill: "#f0f9fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26750",
    "data-name": "Trac\\xE9 26750",
    d: "M33.867,74.095s-2.033,6.709-9.6,4.294L1.121,70.531l-.636-.315s-1.24-.187.246-2.586l2.2-3.9Z",
    transform: "translate(0 -33.344)",
    fill: "#daf0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26751",
    "data-name": "Trac\\xE9 26751",
    d: "M74.8,27.709a2.129,2.129,0,0,0-2.187.855,1.649,1.649,0,0,0-.208.881c-.78,1.571-6.467,16.93-6.467,16.93a27.067,27.067,0,0,1-6.42,10.368c-1.6,1.617-3.334,2.983-4.777,3.214l9.652,3.3Z",
    transform: "translate(-28.64 -14.483)",
    fill: "#bfe4f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26752",
    "data-name": "Trac\\xE9 26752",
    d: "M59.427,15.552a2.171,2.171,0,0,0-2.4,1.736L25.364,5.515l4.153-1.069Z",
    transform: "translate(-13.271 -2.326)",
    fill: "#97c8d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26753",
    "data-name": "Trac\\xE9 26753",
    d: "M32.416,9.4l-.686-3.77a6.551,6.551,0,0,0-2.869-4.555,7.466,7.466,0,0,0-5.59-.907,7.545,7.545,0,0,0-4.934,2.822,6.509,6.509,0,0,0-1.1,5.278l.547,3.007a1.153,1.153,0,0,0,.895,1.072h-.008l.048.009.029.005,2.084.378,2.038-1.116c.037-.018.072-.038.106-.058l.036-.02-.01,0a1.159,1.159,0,0,0,.437-1.3L22.88,7.2a1.532,1.532,0,0,1,.241-1.226A1.651,1.651,0,0,1,24.21,5.33a1.493,1.493,0,0,1,1.857,1.285l.572,3.142a3.879,3.879,0,0,1-.289,2.231,10.7,10.7,0,0,1-1.15,2.087,7.318,7.318,0,0,0-1.04,2.693,10.088,10.088,0,0,0,.017,3.915l.392,2.155a1.155,1.155,0,0,0,.891,1.071l0,0,.049.009.028.005,2.178.394v-.708l1.18-.215a1.169,1.169,0,0,0,1.065-1.539l-.269-1.481a5.219,5.219,0,0,1,.24-2.756,8.731,8.731,0,0,1,1.2-2.305,7.753,7.753,0,0,0,1.167-2.507A7.352,7.352,0,0,0,32.416,9.4",
    transform: "translate(-8.944 0)",
    fill: "#a70013"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26754",
    "data-name": "Trac\\xE9 26754",
    d: "M38.923,52.723c-.026,0-.051-.011-.078-.014l-.012,0h0a1.856,1.856,0,0,0-.545.024l-3.1.564a1.169,1.169,0,0,0-1.065,1.538l.743,4.084q.178.975.952,1.087h0l2.14.394.325-.759,1.215-.221A1.17,1.17,0,0,0,40.57,57.88l-.455-2.5.969-2.264Z",
    transform: "translate(-17.836 -27.573)",
    fill: "#a70013"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26755",
    "data-name": "Trac\\xE9 26755",
    d: "M30.517,24.7a1.169,1.169,0,0,1-1.539-1.065l-.392-2.154a10.079,10.079,0,0,1-.017-3.915,7.3,7.3,0,0,1,1.04-2.693,10.721,10.721,0,0,0,1.15-2.087,3.883,3.883,0,0,0,.289-2.231l-.572-3.142a1.493,1.493,0,0,0-1.857-1.285,1.652,1.652,0,0,0-1.089.639,1.529,1.529,0,0,0-.24,1.226l.555,3.051a1.17,1.17,0,0,1-1.065,1.539l-3.051.555a1.169,1.169,0,0,1-1.539-1.065l-.547-3.007a6.51,6.51,0,0,1,1.1-5.278A7.545,7.545,0,0,1,27.682.966a7.464,7.464,0,0,1,5.59.907,6.547,6.547,0,0,1,2.869,4.555l.686,3.77a7.347,7.347,0,0,1-.122,3.407,7.772,7.772,0,0,1-1.167,2.507,8.732,8.732,0,0,0-1.2,2.305,5.229,5.229,0,0,0-.24,2.756l.27,1.481A1.17,1.17,0,0,1,33.3,24.194Zm1.409,8.507a1.169,1.169,0,0,1-1.539-1.065l-.743-4.084a1.169,1.169,0,0,1,1.065-1.539l3.1-.564a1.17,1.17,0,0,1,1.539,1.065l.743,4.084a1.169,1.169,0,0,1-1.065,1.539Z",
    transform: "translate(-11.252 -0.417)",
    fill: "#de221f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.fe738ab5a26be94ef1c9baa7afdd8cbe.svg";
export { ForwardRef as ReactComponent };